export async function safeJson(response) {
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch {
    throw new Error("Servidor indisponível. Verifique a conexão com o backend.");
  }
}
